import React, {Component} from 'react';
//import { withNavigation } from 'react-navigation'; // 画面遷移時に再描画するために必要 1/4

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

import { iv } from './iv';

/*
class cMsgList extends React.Component {

  state = cf.myRN_crt_stss({
    sdd_ct21ss: [],
  })

  componentDidMount() {
    cf.myRN_stt(this, ()=>{ // 画面遷移時に再描画するために必要 2/4
      global.c.load();
    });
  }

  componentWillUnmount() {
    cf.myRN_end(); // 画面遷移時に再描画するために必要 3/4
  }

  load = () => {
    cf.myRN_load([
      new Promise( _o_end1 => {
        //
        let _cnd = bf.q('[ct21l11e]="cm20" AND [ct21l11k]="{}"'.f(global.c.state.sgcd_pagePntKeys.cm20_key));
        if (bf.f(global.c.state.sgcd_schs.word)) {
          _cnd += cf.psql(' AND [ct21c310] LIKE "%{}%"'.f(global.c.state.sgcd_schs.word));
        };            
        cf.myCB_set_items('sdd_ct21ss', 'ct21', _cnd, '{_KEY}', {
          pfx:{
            type:'val', 
            val:'{ct21c310}',
          },
        })
        .then(()=>{
          _o_end1();
        });
      }),
    ]);
  }

  render() {
    return (
      <>
        <ce.RootList
          crrPage='cMsgList'
          d_hdrs={global.c?.state.sgcd_hdrs}
          b_logo={false}
          b_sch={true}
          onSchEnt={()=>{
            global.c.load();
          }}
          rhtIconName='plus'
          rhtPfx='新規'
          n_bdyW={ic.gn_w}
          onRhtPrs={()=>{
            let _d_pageInfs = {
              sgc_pageRole: global.c?.state.sgc_pageRole,
              sgc_pageName: 'cMsgSet',
              sgc_pagePntKey: '',
              sgc_pageKey: '',
              sgc_pageMode: 'new',
              sgc_pagePrc: '',
              sgcb_pageEdt: true,
            };
            cf.myRN_move_fwd(_d_pageInfs);
          }}
          d_bdys={global.c?.state.sgcd_bdys}
        />
      </>
    );
  }
}

export default withNavigation(cMsgList); // 戻るで再描画するために必要 4/4
*/

import cView from './cView';

export default class cMsgList extends cView {

  $id_stgs = { //  子で上書き
  };

  $cd_stss = { // 親を上書き
  };

  $clp_loads = () => [ // 親を上書き
    new Promise( _o_end1 => {
      //
/*
      let _cnd = bf.q('[ct21l11e]="cm20" AND [ct21l11k]="{}"'.f(
//      let _cnd = bf.q('[ct21l11e]="cm20" AND [ct21l11k]="{}" AND IFNULL(ct21cz10,"10")<>"0"'.f( // 20211003
        global.c?.state.sgcd_pagePntKeys.cm20_key,
      ));
*/
      let _cnd = bf.q(`
        IFNULL(ct21cz10,"10") <> "0"
        AND ct21l11e = "cm20"
        AND ct21l11k = "{}"
        AND [_KEY] IN (
          SELECT
            ct22b11k::NUMERIC::INTEGER
          FROM
            t_ct22
          WHERE
            IFNULL(ct22cz10,"10") <> "0"
            AND ct22b21k = "{}"
        ) 
      `.f( // 20211003
        global.c?.state.sgcd_pagePntKeys.cm20_key,
        global.c?.state.sgcd_pagePntKeys.cm10_key,
      ));
//bf.l('117: {}'.f(_cnd))
/*
          ct22b11k: global.c?.state.sgcd_pagePntKeys.ct21_key,
          ct22b21k: _d_items.key,
*/

      cf.myCB_set_items({
        state: 'sld_ct21ss', 
        ctr: 'nlm',
        elm: 'ct21', 
        n_dms: 3,
        cnd: _cnd, 
        o_fnc: _d_ct21s => {
//bf.l('cMsgList 108:{}'.f(_d_ct21s))
          return {
            pfx: '{}'.f(_d_ct21s.ct21c310),
          }
        },
      })
      .then(()=>{
        _o_end1();
      });
    }),
  ];

  render() {
    return ( //  子で上書き
      <ce.RootDtl
        b_logo={false}
        b_sch={false}
        onSchEnt={null}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iMsgSet',
            sgc_pagePntKey: '',
            sgc_pageKey: '',
            sgc_pageMode: 'new',
            sgc_pagePrc: '',
            sgcb_pageEdt: true,
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        n_bdyW={ic.gn_w}
        d_hdrs={{
          pfx: iv._get_hdrPfx('メッセージグループ一覧'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgc_pageMode),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_ct21ss',
              nextRole: global.c?.state.sgc_pageRole,
              nextPage: 'iMsgDtl',
              b_edt: false,
              b_img: false,
              b_bdr: false,
            },
          ],
        }}
      />
    );
  }

}
